/*
 * File: ApptDataModel.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 05/20/2020
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: Appt data model to be used for the state tree
 */

import { types } from "mobx-state-tree";

const ApptDataModel = {
  appointmentId: types.optional(types.number, 0),
  appointmentDate: types.optional(types.Date, new Date()),
  appointmentTime: types.optional(types.Date, new Date()),
  birthday: types.maybe(types.string),
  colors: types.optional(types.frozen(types.frozen), {}),
  displayId: types.optional(types.string, ""),
  end: types.maybeNull(types.Date),
  error: types.maybe(types.frozen(types.frozen)),
  lastAppointment: types.maybe(types.string),
  lastAppointmentId: types.maybe(types.number),
  length: types.maybe(types.number),
  nextAppointment: types.maybe(types.string),
  nextAppointmentId: types.maybe(types.number),
  notes: types.optional(types.string, ""),
  patientFirstName: types.optional(types.string, ""),
  patientId: types.maybe(types.number),
  patientLastName: types.optional(types.string, ""),
  patientProviderId: types.maybe(types.number),
  photoHash: types.maybe(types.string),
  providerFirstName: types.optional(types.string, ""),
  providerID: types.optional(types.number, 0),
  providerLastName: types.optional(types.string, ""),
  providerName: types.optional(types.string, ""),
  resource: types.maybe(types.string),
  resourceId: types.optional(types.number, 0),
  resourceProviderId: types.maybe(types.number, 0),
  //Just used for communicating with the API
  start: types.maybeNull(types.Date),
  startTime: types.maybeNull(types.Date),
  status: types.maybe(types.string),
  statusId: types.optional(types.number, 0),
  type: types.maybe(types.string),
  typeId: types.optional(types.number, 0),
};

export default ApptDataModel;
